import { Accordion, AccordionDetails, Typography, Button } from "@material-ui/core";
import useStyles from "../../assets/styles/styles";
import NotificationsIcon from '@material-ui/icons/Notifications';
import StarIcon from '@material-ui/icons/Star';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectCommunication, modifyCommunication, updateAllCommunication } from "../../redux/actions/communicatedAction";
import { Box } from "@mui/material";

const CardCommunication = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const comunicacionReducer =useSelector((state) => state.communicatedReducer.communication);

    const viewDetalle = (position) => {
        const newCommunications = comunicacionReducer?.communication.map((item, i) => {
            if (position === i) {
                return { ...item, viewed: true };
            } else {
                return item;
            }
        });
        let notificationSelected = props.communication;
        notificationSelected.viewed =true; 
        dispatch(selectCommunication(notificationSelected));
        dispatch(modifyCommunication(notificationSelected));
        dispatch(updateAllCommunication({ communications: newCommunications }));
        history.push('/Communication');
    };

    const AddIcon = () => {
        let response = <NotificationsIcon className={`${classes.notificationIcon}  ${classes.iconNotifactionCarCommunications}`}/>;
        if (props?.communication?.favourite) {
            response = <StarIcon className={`${classes.iconDestacate} ${classes.iconNotifactionCarCommunications}`}/>;
        } else if (props?.communication?.viewed) {
            response = <NotificationsIcon className={`${classes.iconReader} ${classes.iconNotifactionCarCommunications}`}/>;
        }
        return response;
    };

    return (
        <Accordion className="communication" key={props?.communication?.id} expanded={true}>
            <AccordionDetails className="notification">
                <Box className={`${classes.flexRow} ${classes.boxCardCommunications}`}>
                    <Box className={classes.cardComunication}>
                        {AddIcon()}
                        <Box className={classes.boxDescriptionCardCommunications}>
                            <Typography className={`${classes.txtDescription} ${classes.txtDescriptionTruncate}`}>
                                {props?.communication?.title}
                            </Typography>
                            <Typography className={`${classes.txtSubtitleBlue} ${classes.txtEllipsis}`}>
                                {props?.communication?.author}
                            </Typography>
                            <Typography className={`${classes.txtDescription} ${classes.txtDescriptionTruncate}`}>
                                {props?.communication?.description}
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography className={classes.txtDescription}>
                            {new Date(props?.communication?.initialDate)?.toLocaleDateString()}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            onClick={() => viewDetalle(props?.position)}
                            className={`${classes.lightLinearGradient} ${classes.customButtomViewDetails}`}
                        >
                            {'ver detalle'}
                        </Button>
                    </Box>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default CardCommunication;
